import { FunctionComponent } from "react";

import {
  SecurityRolesSelect,
  SecurityRolesSelectProps
} from "../../pickers/SecurityRolesSelect";
import { useFieldContext, useFieldRegister } from "@bps/fluent-ui";

type ExpSecurityRolesSelectFieldProps = Omit<
  SecurityRolesSelectProps,
  "selectedKeys" | "onChangeSelectedKeys"
> & { name: string };

export const ExpSecurityRolesSelectField: FunctionComponent<ExpSecurityRolesSelectFieldProps> = ({
  name,
  ...restSecurityRolesSelectProps
}) => {
  useFieldRegister(name);
  const { value, setFieldValue, disabledForm } = useFieldContext<
    string | string[] | undefined
  >(name);

  return (
    <SecurityRolesSelect
      selectedKeys={value}
      onChangeSelectedKeys={setFieldValue}
      {...restSecurityRolesSelectProps}
      disabled={restSecurityRolesSelectProps.disabled || disabledForm}
    />
  );
};
